import { render, staticRenderFns } from "./FooterNavIte.vue?vue&type=template&id=706acf00&scoped=true&"
import script from "./FooterNavIte.vue?vue&type=script&lang=js&"
export * from "./FooterNavIte.vue?vue&type=script&lang=js&"
import style0 from "./FooterNavIte.vue?vue&type=style&index=0&id=706acf00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706acf00",
  null
  
)

export default component.exports